import type { FieldProps } from '@seek/forms-ui/lib/Field/Field';
import { useTranslations } from '@vocab/react';
import { Box, Notice, RadioGroup, RadioItem, Text } from 'braid-design-system';
import type React from 'react';

import translations from 'src/App/Components/UserFormProvider/.vocab';
import { Role } from 'src/graphql/generated';

import type { UserFormValues } from '../userFormFields';

interface AddTeamMemberFormProps {
  disableAdminRole: boolean;
  disableAllRoles?: boolean;
  onRoleTypeChange: (changeEvent: React.ChangeEvent<any>) => void;
  role: FieldProps<UserFormValues, 'role', any, any>;
}

export const FormRoles = ({
  disableAdminRole,
  disableAllRoles,
  onRoleTypeChange,
  role,
}: AddTeamMemberFormProps) => {
  const { t } = useTranslations(translations);

  return (
    <Box>
      <RadioGroup
        label="Role"
        id="role"
        disabled={disableAllRoles ?? false}
        {...role}
        {...(onRoleTypeChange && { onChange: onRoleTypeChange })}
      >
        <RadioItem label={t('Team member')} value={Role.USER} />
        <RadioItem
          label={t('Administrator')}
          value={Role.ADMINISTRATOR}
          description={t('Administrator role message')}
          disabled={disableAdminRole}
        />
      </RadioGroup>
      {disableAdminRole && (
        <Box paddingLeft="large" paddingTop="medium">
          <Notice tone="info">
            <Text>{t('Admin role disable message')}</Text>
          </Notice>
        </Box>
      )}
    </Box>
  );
};
